import { useTour } from "@/components/tour/TourProvider";
import { tourIdForTab } from "@/components/tour/registry";
import { GuideNudgeBanner } from "@/components/guide-nudge-banner";

// Surfaces the host-app GuideNudgeBanner at the top of each vendor-portal tab
// that has a registered tour. The vendor portal runs its own TourProvider (not
// the host-app MiniTour), so we inject `hasGuide`/`onStartGuide` from useTour
// and resolve the active tab's tour via `tourIdForTab`. The persistence key is
// namespaced (`vendor-<tourId>`) so a dismiss here never collides with the
// identically-named host-app guide (e.g. "tasks"). No explainer-video catalog
// exists for the portal, so that lookup is disabled.
export function VendorGuideNudge({ activeTab, hostsSubView }: { activeTab: string; hostsSubView: "list" | "hostDetail" }) {
  const { hasTour, startTour } = useTour();
  const tourId = tourIdForTab(activeTab, hostsSubView);
  if (!tourId) return null;
  return (
    <GuideNudgeBanner
      pageKey={`vendor-${tourId}`}
      hasGuide={hasTour(tourId)}
      onStartGuide={() => startTour(tourId)}
      enableExplainerVideo={false}
    />
  );
}
